import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs/operators';

import { SessionService } from '../../services/session.service';

const handleInterception = (
  token: string | null,
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  if (token) {
    return next(
      request.clone({
        setHeaders: {
          ['Authorization']: `Bearer ${token}`,
        },
      }),
    );
  }

  return next(request);
};

export const createAuthInterceptor = (noAuthDomains: string[]) => {
  const authInterceptor: HttpInterceptorFn = (request, next) => {
    const requestUrl = new URL(request.url, window.location.origin);

    if (
      noAuthDomains.find((noAuthDomain) => {
        const domain = new URL(noAuthDomain);

        return (
          requestUrl.hostname === domain.hostname &&
          requestUrl.pathname === domain.pathname
        );
      })
    ) {
      return next(request);
    }

    return inject(SessionService)
      .checkToken()
      .pipe(switchMap(({ token }) => handleInterception(token, request, next)));
  };

  return authInterceptor;
};
